"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _button = _interopRequireDefault(require("../button"));
var _icon = _interopRequireDefault(require("../icon"));
var _pinFilled = _interopRequireDefault(require("../../icons/pin-filled"));
require("./find-a-store-pin.css");
var _excluded = ["className", "text"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Lockup of a location pin icon and text; intended use is for creating links to store locator.
 */
var FindAStorePin = function FindAStorePin(_ref) {
  var className = _ref.className,
    text = _ref.text,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!text) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
    className: (0, _classnames["default"])('text-noUnderline text-semibold sb-findAStorePin', _defineProperty({}, className, Boolean(className))),
    color: "black",
    visualStyle: "textLink"
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "pr2",
    path: _pinFilled["default"],
    size: "32px"
  }), text);
};
FindAStorePin.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional CSS class for the button
   */
  className: _propTypes["default"].string,
  /**
   * Text next to the pin
   */
  text: _propTypes["default"].string
} : {};
var _default = exports["default"] = FindAStorePin;